export default "__VITE_ASSET__Dy4D9h9f__";